export default "__VITE_ASSET__48736d95__"